import React from 'react';
import MuiCssBaseline from '@material-ui/core/CssBaseline';

const CssBaseline = props => <MuiCssBaseline {...props} />;

export default CssBaseline;
